/* dv-card-peek 2026-07-02 v3: on touch devices, pressing a product-card photo
   (held ~150ms without scrolling) reveals the product's second image with a
   slow zoom; releasing fades back. A HOLD never opens the product - only a
   distinct quick tap (<150ms) navigates. A scroll gesture never triggers it.
   Also: iOS link-preview sheet suppressed via -webkit-touch-callout (CSS) and
   image drag-out disabled; lazy 18px placeholders are preloaded to width=720
   via IntersectionObserver so the reveal is sharp instantly. */
(function () {
  if (!('ontouchstart' in window)) return;

  function upgrade(sec) {
    if (!sec || sec.dataset.dvUp) return;
    sec.dataset.dvUp = '1';
    var big = (sec.currentSrc || sec.src || '').replace(/width=\d+/, 'width=720');
    if (big) { sec.srcset = ''; sec.removeAttribute('sizes'); sec.src = big; }
  }

  // iOS long-press also tries to DRAG the image out of the card, which fights
  // the hold-to-peek gesture - disable dragging on all card images.
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest('.product__media')) e.preventDefault();
  }, true);
  function undraggable() {
    document.querySelectorAll('.product__media img:not([data-dv-nodrag])').forEach(function (img) {
      img.dataset.dvNodrag = '1';
      img.draggable = false;
    });
  }

  // Preload second images as cards approach the viewport (200px early), so a
  // press reveals a sharp photo instantly instead of an upscaled placeholder.
  function arm() {
    undraggable();
    var cards = document.querySelectorAll('.product__media.show_secondary img.secondary-image:not([data-dv-up])');
    if (!('IntersectionObserver' in window)) { cards.forEach(upgrade); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { upgrade(en.target); io.unobserve(en.target); }
      });
    }, { rootMargin: '200px' });
    cards.forEach(function (img) { io.observe(img); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
  // re-arm for cards injected later (filters, infinite scroll, sliders)
  new MutationObserver(function () {
    clearTimeout(arm._t); arm._t = setTimeout(arm, 400);
  }).observe(document.body, { childList: true, subtree: true });

  var timer = null, media = null, sx = 0, sy = 0, held = false, suppressUntil = 0;

  // A hold is a PEEK, never a click-through: swallow the synthetic click that
  // follows touchend whenever the gesture lasted long enough to reveal.
  document.addEventListener('click', function (e) {
    if (Date.now() < suppressUntil && e.target.closest && e.target.closest('.product__media')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  function imgs(m) {
    return {
      sec: m.querySelector('img.secondary-image'),
      first: m.querySelector('img.product-image:not(.secondary-image), .first-image'),
    };
  }
  function show(m, el) {
    el.sec.style.setProperty('opacity', '1', 'important');
    el.sec.style.setProperty('transform', 'scale(1.12)', 'important');
    if (el.first) el.first.style.setProperty('opacity', '0', 'important');
  }
  function peek(m) {
    var el = imgs(m);
    if (!el.sec) return;
    upgrade(el.sec);
    if (el.sec.complete && el.sec.naturalWidth > 100) { show(m, el); return; }
    el.sec.addEventListener('load', function onload() {
      el.sec.removeEventListener('load', onload);
      if (media === m) show(m, el);
    });
  }
  function unpeek(m) {
    var el = imgs(m);
    if (el.sec) { el.sec.style.removeProperty('opacity'); el.sec.style.removeProperty('transform'); }
    if (el.first) el.first.style.removeProperty('opacity');
  }
  function reset() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (media) { unpeek(media); media = null; }
    held = false;
  }

  // 2026-07-27 (owner): "More in this colour / We Think You'll Love / Recently
  // Viewed are not horizontally scrolling because the image swap is working
  // instead". Those rows are horizontal scrollers, and a slow drag across a card
  // never moves 12px inside the 150ms window, so the hold fires, the second image
  // swaps in, and the gesture reads as a peek rather than a scroll. Peek belongs
  // on a static grid, not inside a carousel - so skip any card that sits in a
  // horizontally scrollable ancestor. Detected structurally rather than by class
  // name so it covers every carousel on the site, including ones added later.
  function dvInHorizontalScroller(el) {
    for (var n = el; n && n !== document.body; n = n.parentElement) {
      var cs;
      try { cs = getComputedStyle(n); } catch (err) { return false; }
      if ((cs.overflowX === 'auto' || cs.overflowX === 'scroll') &&
          n.scrollWidth > n.clientWidth + 20) return true;
    }
    return false;
  }
  document.addEventListener('touchstart', function (e) {
    reset();
    var m = e.target.closest && e.target.closest('.product__media.show_secondary');
    if (!m) return;
    if (dvInHorizontalScroller(m)) return; // let the carousel scroll instead
    var t = e.touches[0];
    media = m; sx = t.clientX; sy = t.clientY; held = false;
    var el = imgs(m);
    if (el.sec) upgrade(el.sec); // start the download during the hold delay
    timer = setTimeout(function () {
      held = true; // long enough to count as a hold, not a tap
      if (media) peek(media);
    }, 150);
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    // Movement only cancels a hold that hasn't fired yet (i.e. it's a scroll).
    // Once the peek is showing, sliding the finger around keeps the 2nd image
    // up until release.
    if (!media || held) return;
    var t = e.touches[0];
    if (Math.abs(t.clientX - sx) > 12 || Math.abs(t.clientY - sy) > 12) reset();
  }, { passive: true });
  document.addEventListener('touchend', function () {
    if (timer) { clearTimeout(timer); timer = null; }
    var m = media, wasHeld = held;
    media = null; held = false;
    if (wasHeld) suppressUntil = Date.now() + 700; // a hold never opens the product
    if (m) setTimeout(function () { unpeek(m); }, wasHeld ? 450 : 0);
  }, { passive: true });
  document.addEventListener('touchcancel', reset, { passive: true });
})();
